export default "__VITE_ASSET__BoCTCrps__"